// extracted by mini-css-extract-plugin
export default {"home":"home_home__gBpLN","content":"home_content__f-8Gc","info":"home_info__Q6kPc"};